import { Component, DoCheck, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from './core/services/auth.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { AuthenticationRepository } from './core/repositories/authentication.repository';
import { TranslateService } from '@ngx-translate/core';
import { ToastMessageService } from './core/services/toast-message.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  useId: number = 0;
  protected subscriptions: Subscription[] = [];
  protected ngUnsubscribeHttp: Subject<void> = new Subject<void>();

  constructor(
    private translateService:TranslateService,
    private authenticationRepository: AuthenticationRepository,
    private authService: AuthService,
    private toastService: ToastMessageService,
  ) { 
    this.translateService.setDefaultLang('vi');
    this.translateService.use(localStorage.getItem('lang') || 'vi')
  }

  ngOnInit(): void {
    if (typeof window !== 'undefined') {
      this.useId = Number(localStorage.getItem('userId'));
    }
    if (this.useId) {
      this.initComp();
    }
  }

  initComp() {
    this.authenticationRepository
      .getUserInfo(this.useId)
      .pipe(takeUntil(this.ngUnsubscribeHttp))
      .subscribe((res) => {
        console.log(res, '----res');

        if (res.data && res.meta?.error_code === 200) {
          const user = res.data;
          this.authService.setUserInfo(user);
        }
        else {
          this.toastService.show(res.meta?.error_message ?? "Thất bại!", 'error');
        }
      });
  }
}
